import React from "react";

export default function Resume() {
  return (
    <div className="container-fluid py-5 bg-dark ">
      
      <iframe
        src="/resume.html"
        style={{ width: "100%", height: "1000px", border: "none" }}
        title="Resume"
      ></iframe>
      
    </div>
  );
}
